'use client';

import { memo } from 'react';

import { type Board } from '@air/api/types';

import { useLibraryPermissions } from '~/components/LibraryBeta/hooks/useLibraryPermissions';
import { LibraryHeaderCreateButton } from '~/components/LibraryBeta/LibraryHeaderCreateButton';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';

export type LibraryTopBarAddButtonProps = {
  library: NonNullable<Board['library']>;
};

export const LibraryTopBarAddButton = memo(({ library }: LibraryTopBarAddButtonProps) => {
  const { libraryPermissions } = useLibraryPermissions({ libraryId: library.id });
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();

  return (
    <LibraryHeaderCreateButton
      data-testid="LIBRARY_HEADER_CREATE_BUTTON"
      library={library}
      libraryPermissions={libraryPermissions}
      workspacePermissions={workspacePermissions}
    />
  );
});

LibraryTopBarAddButton.displayName = 'LibraryTopBarAddButton';
